import { TranslateService } from "@ngx-translate/core";

export class CommonService {
  static doctorDetails: any;
  static meetingUrl: any;
  static startTime: any;
  static timeDuration: any;
  static androidLatitude: any;
  static androidLongitude: any;
  address: any;
  profileImage: any;
  profileaddress: any = '';
  doctorDetails: any;
  doctorSpecialityList: any = [];
  commonNotification: any;
  videoSound: any;
  static videoSound: any;

  static setDoctorDetails(item) {
    CommonService.doctorDetails = item;
  }
  static setDoctorVideo(item) {
    CommonService.videoSound = item;
  }
  static setAndLat(item) {
    CommonService.androidLatitude = item;
  }
  static setAndLong(item) {
    CommonService.androidLongitude = item;
  }

  static setVideocallUrl(url, time, duration) {
    this.meetingUrl = url;
    this.startTime = time;
    this.timeDuration = duration;
  }

  static getTimeDiffernce(aptTime, aptDate) {
    var crtTime: any;
    var time1;
    if (aptDate.indexOf("T") > -1) {
      time1 = new Date(aptDate.split("T")[0] + "T" + aptTime).getTime();
    } else if (aptDate.indexOf(" ") > -1) {
      time1 = new Date(aptDate.split(" ")[0] + "T" + aptTime).getTime();
    } else {
      time1 = new Date(aptDate + "T" + aptTime).getTime();
    }
    var time2 = new Date().getTime();
    var difference = time2 - time1;
    console.log(time1);
    console.log(difference);
    if (difference >= 0 && difference <= 900000) {
      return "valid";
    }
    return "invalid";
  }


  static getTimeDiffernce1(aptTime, aptDate) {
    var crtTime: any;
    var time1;
    if (aptDate.indexOf("T") > -1) {
      time1 = new Date(aptDate.split("T")[0] + "T" + aptTime).getTime();
    } else if (aptDate.indexOf(" ") > -1) {
      time1 = new Date(aptDate.split(" ")[0] + "T" + aptTime).getTime();
    } else {
      time1 = new Date(aptDate + "T" + aptTime).getTime();
    }
    var time2 = new Date().getTime();
    var difference = time2 - time1;
    //console.log(time1);
    // console.log(difference);
    // if (difference >= -300000 && difference <= 0) {
    //   return "valid";
    // }
    // return "invalid";
    return difference;
  }

  setDoctorVideo(video) {
    if (video) {
      this.videoSound = video
    }
  }

  setDoctorDetails(details) {
    if (details) {
      console.log('details', ' ', details);

      this.doctorDetails = details[0];
      this.doctorDetails.nationality_id = String(this.doctorDetails.nationality_id);
      localStorage.setItem("doctorName", details[0].doctorName);
      localStorage.setItem("doctorImage", details[0].profileImage);
    }
  }
  setDoctorSpeciality() {
    this.doctorSpecialityList = [];
    console.log(this.doctorDetails.speciality);

    for (let val of JSON.parse(this.doctorDetails.speciality)) {
      this.doctorSpecialityList.push(val);
    }
  }


  // setCommonNotification(data: any) {
  //   this.commonNotification = data
  // }

}